export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">联系我们</h2>
        <p className="section-subtitle">有任何建议、合作意向或内容投稿？欢迎通过以下方式联系</p>
        <div className="mt-10 max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10 text-center">
            <div className="w-16 h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-5">
              <i className="ri-mail-line text-primary-600 text-2xl"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">
              商务合作 &amp; 内容投稿
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              宅男视频欢迎各大视频平台、内容创作者和品牌方与我们联系。
              无论是平台接入、联合企划还是广告合作，我们都有专业的团队为你服务。
              用户反馈和建议也可以通过下方邮箱直达运营团队。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:contact@zhainanvideo.example.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-send-line"></i>
                发送邮件
              </a>
              <span className="text-sm text-foreground-500 whitespace-nowrap">
                contact@zhainanvideo.example.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}